var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6201 14.5H12.6201M12.6201 14.5H14.6201M12.6201 14.5V16.5M12.6201 14.5V12.5",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62012 7.44975C2.62012 6.56722 2.62012 6.12595 2.68947 5.75839C2.99476 4.14031 4.26043 2.87464 5.87851 2.56935C6.24607 2.5 6.68734 2.5 7.56987 2.5C7.95654 2.5 8.14988 2.5 8.33569 2.51738C9.13677 2.59229 9.89664 2.90704 10.5161 3.42051C10.6597 3.53961 10.7964 3.67633 11.0698 3.94975L11.6201 4.5C12.4359 5.31578 12.8438 5.72367 13.3322 5.99543C13.6005 6.14471 13.8852 6.2626 14.1805 6.34678C14.718 6.5 15.2948 6.5 16.4485 6.5H16.8222C19.4546 6.5 20.7707 6.5 21.6263 7.26946C21.705 7.34024 21.7799 7.41514 21.8506 7.49383C22.6201 8.34935 22.6201 9.66554 22.6201 12.2979V14.5C22.6201 18.2712 22.6201 20.1569 21.4485 21.3284C20.277 22.5 18.3913 22.5 14.6201 22.5H10.6201C6.84888 22.5 4.96327 22.5 3.79169 21.3284C2.62012 20.1569 2.62012 18.2712 2.62012 14.5V7.44975Z",
    stroke: "#313131",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddFolder);
export default __webpack_public_path__ + "static/media/icon-add-folder.a0893ca737c3448551d23e6a9f06bbe0.svg";
export { ForwardRef as ReactComponent };